import React, { useState, useEffect, useMemo } from 'react';

interface IUseOnScreenProps {
  targetRef: React.MutableRefObject<HTMLElement | undefined>;
  /* eslint-disable no-undef */
  observerOptions?: IntersectionObserverInit;
}

// обсервер, сигналящий когда элемент попадает в зону видимости
const useOnScreen = ({ targetRef, observerOptions = {} }: IUseOnScreenProps) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const element = targetRef.current;

    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), {
      ...observerOptions,
    });

    if (element) observer.observe(element);
    return () => {
      if (element) observer.disconnect();
    };
  }, [targetRef, observerOptions]);

  return useMemo(() => {
    return isIntersecting;
  }, [isIntersecting]);
};

export default useOnScreen;
